import { FaInfoCircle } from "react-icons/fa";

const Tooltip = ({ text, position = "right", className = "" }) => (
    <span className={`ltooltip-container ${className}`}>
        <FaInfoCircle className="ltooltip-icon" aria-hidden="true" />
        <span className={`ltooltip-text ltooltip-${position}`} role="tooltip">
            {text}
        </span>
    </span>
);

export default Tooltip;
